import { render, staticRenderFns } from "./MaterialItemDetails.vue?vue&type=template&id=2c6d7b42&scoped=true&"
import script from "./MaterialItemDetails.vue?vue&type=script&lang=js&"
export * from "./MaterialItemDetails.vue?vue&type=script&lang=js&"
import style0 from "./MaterialItemDetails.vue?vue&type=style&index=0&id=2c6d7b42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6d7b42",
  null
  
)

export default component.exports